<template>
  <ui-dialog
    :show="isOpen"
    persistent
    scrollable
    max-width="623"
    @input="close"
  >
    <template #header>
      <h3>
        {{ $t("message.facilityDetails.openStatusDialog.title") }}
      </h3>
    </template>
    <template #default>
      <div class="open-close-facility">
        <v-radio-group
          class="mt-0"
          v-model="chosenOpenStatus"
          color="primary"
          row
        >
          <v-radio
            v-for="status in openStatuses"
            class="list-item"
            :key="status"
            :label="$t(`message.openStatusTypes.${status}`)"
            :value="status"
          ></v-radio>
        </v-radio-group>
      </div>
    </template>
    <template #actions>
      <div class="d-flex justify-end w-100">
        <ui-button color="primary" @click="save" :disabled="!chosenOpenStatus">
          {{ $t("message.common.save") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import { OPEN_STATUS } from "@/enums/open-status-type";

export default {
  name: "OpenCloseFacilityDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    currentOpenStatus: {
      type: Number,
      validator: value => Object.values(OPEN_STATUS).includes(value)
    }
  },
  data() {
    return {
      loading: false,
      chosenOpenStatus: null,
      openStatuses: [
        OPEN_STATUS.OPEN,
        OPEN_STATUS.CLOSED_PERMANENTLY,
        OPEN_STATUS.CLOSED_TEMPORARILY
      ]
    };
  },
  watch: {
    async isOpen(newValue) {
      this.chosenOpenStatus = newValue ? this.currentOpenStatus : null;
    }
  },
  created() {
    this.chosenOpenStatus = this.currentOpenStatus;
  },
  methods: {
    close() {
      this.$emit("close");
    },

    save() {
      this.$emit("save", { openStatus: this.chosenOpenStatus });
      this.close();
    }
  }
};
</script>

<style lang="scss">
.open-close-facility {
  display: flex;
  flex-direction: column;
  padding-top: $spacing;
  margin-bottom: -$spacing;
  border-top: 1px solid $light-3;

  .list-item {
    display: flex;
    justify-content: space-between;
    margin-right: 0 !important;
    padding: $spacing * 1.75 0;
    padding-right: $spacing * 4;
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.v-label {
  padding-left: $spacing;
}

.dialog-header {
  margin-right: 0 !important;
}

.v-card__title {
  padding-bottom: $spacing * 3;

  h3 {
    line-height: 36px;
  }
}
</style>
